import axios from 'axios'
import router from '@/router'

const actions = {
    // clear user saved sessions and tokens to deny access to further pages after signOut
    async signOut ({ dispatch, getters }) {
        let userObj = {
            userId: getters.authenticated ? getters.user._id : ''
        }
        try {
            await axios.post('/users/signout', userObj)
        }
        catch(e) {}

        // empty out the stored values
        dispatch('emptyThem')

        // redirect to login page
        router.replace({name: 'signin'}).catch((e) => {})
    },
    async emptyThem({ commit }) {
        // reset localStorage 
        localStorage.removeItem('_m12tk10q') // token
        localStorage.removeItem('_d11ed20d') // expirationDate
        localStorage.removeItem('_t13st40q') // shopToken

        // reset vuex states
        commit('SET_TOKEN', null)
        commit('SET_USER', null)
        commit('SET_SHOP', null)
        commit('SET_CARD', null)
        commit('SET_CARDS', null)
        commit('SET_PREVIEW', null)
        commit('SET_ANEWITEM', null)
        commit('MY_SELLINGS', null)
        commit('MY_BUYINGS', null)
        commit('MODIFY_ITEM', null)
        commit('LIKED_ITEMS', null)
        commit('LOOKUP_USER', null)
        commit('ITEM_BUYERS', null)
        commit('ITEMS_SELLER', null)
        commit('MSG_THREAD', null)
        commit('NAV_COUNTER', null)
        commit('ACCT_COUNTER', null)
        commit('SET_ALERTS', null)
        commit('SET_REVIEWS', null)
        commit('SET_FOLLOWERS', null)
        commit('SET_FOLLOWING', null)
        commit('SET_TRANSACTION', null)
        commit('SET_TRANSACTIONS', null)
        commit('REVIEW_TRANSACTION', null)
        commit('MAS_ITEM_BUYERS', null)
        commit('MAS_ITEMS_SELLER', null)
        commit('SET_DASHBOARD', null)
        commit('SET_WALLET', null)
        commit('SET_SHOPPERS', null)
        commit('SHOPPER_RECORDS', null)
        commit('DONATIONS_HISTORY', null)
        commit('PROMOTION_RECORDS', null)
        commit('ITEMS_COUNTRY', null)
    }
}

export default {
    actions
}